<div class="helper-container">
  <!--pantalla 1 datos y mail empleador-->
  <section *ngIf="!showConfirmationWindowBool">
    <header class="header-container">
      <div class="button-back-container">
        <ion-col size="3">
          <ion-button class="button-back" fill="clear" routerLink="/home/ccv/option-modify">
            <left-arrow-svg class="button-back-icon"></left-arrow-svg>
            <chevron-back-svg class="chevron-back-icon"></chevron-back-svg>
            Volver
          </ion-button>
        </ion-col>
      </div>
      <ion-toolbar class="ion-no-padding ion-no-margin">
        <div class="title-helper">
          Cambiar a régimen {{ getOtherRegimen(subscriptionDataToModify.taxRegimeCode) }}
        </div>
      </ion-toolbar>
    </header>
    <div>
      <p class="info-notification">
        Pasarás del régimen {{ subscriptionDataToModify.taxRegimeCode }} al 
        {{ getOtherRegimen(subscriptionDataToModify.taxRegimeCode) }}
      </p>
    </div>

    <div>
      <ion-row>
        <div class="notification-subtitle mt-16">
          Notificación a tu empleador
        </div>
        <div class="mt-16 info-notification font-weight-400">
          Por favor, verifica que el correo de tu empleador esté correcto,
          ya que le notificaremos para que realice la modificación de tu ahorro.
        </div>
      </ion-row>

      <ion-row [formGroup]="frmEmployerMail" class="mt-8">
        <ion-col size="12" class="ion-no-margin ion-no-padding mt-28">
          <div style="max-width: 396px;">
            <app-outline-input
              type="email"
              formControlName="email"
              label="Ingresa el correo de tu empleador"
              errorMessage="Por favor, ingresa un correo para notificarle"
              (ionChange)="handleMailInputChange()"
              [isPassword]="false"
            >
            </app-outline-input>
          </div>
        </ion-col>
      </ion-row>
    </div>

    <ion-row class="controllers ion-justify-content-between ion-wrap-reverse">
      <ion-button id="btn-go-back" routerLink="/home/ccv/detail" class="secondary-button font-weight-700">
        Salir
      </ion-button>
      <ion-button
        id="btn-confirm-modify-regimen"
        (click)="goToSecondScreen()"
        (keypress)="true"
        [disabled]="isActiveButtonConfirmation"
        class="primary-button"
        [class]="updateClassContinueButtonFirstScreen()"
      >
        <span class="font-weight-700 mr-23">Continuar</span>
        <span>
          <right-arrow-svg
            [fillColor]="updateClassArrowNextButton()"
          ></right-arrow-svg>
        </span>
      </ion-button>
    </ion-row>
  </section>

  <!--pantalla 2 confirmacion-->

  <section *ngIf="showConfirmationWindowBool">
    <header  class="header-container">
      <div class="button-back-container">
        <ion-col size="3">
          <ion-button class="button-back" fill="clear" (click)="goBackToFirstScreen()" (keypress)="true">
            <left-arrow-svg class="button-back-icon"></left-arrow-svg>
            <chevron-back-svg class="chevron-back-icon"></chevron-back-svg>
            Volver
          </ion-button>
        </ion-col>
      </div>
    </header>

    <div>
      <ion-grid>
        <ion-row class="ion-justify-content-between ion-nowrap">
          <div class="title-helper ion-align-items-center confirmation-helper-mobile">
            Confirma los datos
          </div>
        </ion-row>
        <ion-row class="mt-16">
          <ion-col size="12">
            <div class="info-notification">
              Verifica que tu modificación esté correcta
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="mt-24">
          <ion-col size="6">
            <ion-label class="apv-text modify-text-subtitle-3">Datos de modificación:</ion-label>
          </ion-col>
          <ion-col size="6">
            <div class="modify-button-div-helper">
              <span class="modify-button-container">
                <ion-button class="modify-button" (click)="goBackToFirstScreen()" (keypress)="true" [disabled]="disableEditAndExitButtons">
                  Editar
                </ion-button>
              </span>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="mt-16">
          <ion-col size="7">
            <ion-label class="confirmation-text-col font-weight-500">Nuevo Régimen:</ion-label>
          </ion-col>
          <ion-col size="5">
            <ion-label class="confirmation-text-col">{{ getOtherRegimen(subscriptionDataToModify.taxRegimeCode) }}</ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="mt-16">
          <ion-col size="7">
            <ion-label class="confirmation-text-col font-weight-500">Régimen anterior:</ion-label>
          </ion-col>
          <ion-col size="5">
            <ion-label class="confirmation-text-col">{{ subscriptionDataToModify.taxRegimeCode }}</ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="mt-16">
          <ion-col size="7">
            <ion-label class="confirmation-text-col font-weight-500"
              >Correo de tu empleador:</ion-label
            >
          </ion-col>
          <ion-col size="5" class="confirmation-text-col" style="word-wrap: break-word;">
            {{ frmEmployerMail.get('email')?.value }}
          </ion-col>
        </ion-row>
        <ion-row class="controllers ion-justify-content-between ion-wrap-reverse mt-16">
          <ion-button routerLink="/home/ccv/detail" class="secondary-button font-weight-700"
            [disabled]="disableEditAndExitButtons"
          >
            Salir
          </ion-button>

          <ion-button
            class="primary-button"
            (click)="submitModifyRegimen()"
            (keypress)="true"
            id="modal-modificar-confirmar-button"
            [disabled]="disabledConfirmationButton"

          >
            <ion-label> Confirmar </ion-label>
            <ion-spinner
              class="ml-24"
              name="circular"
              slot="end"
              color="ffffffff"
              *ngIf="showSpinner"
            >
            </ion-spinner>
          </ion-button>
        </ion-row>
      </ion-grid>
    </div>
  </section>
</div>
